export enum BondsSortOption {
  document_date = 'document_date',
  issuer_legal_name = 'issuer_legal_name',
  issue_amount = 'issue_amount',
  maturity_date = 'maturity_date',
  report_title = 'report_title',
  document_name = 'document_name',
}

export enum LoansSortOption {
  borrower_legal_name = 'borrower_legal_name',
  issue_amount = 'issue_amount',
  report_title = 'report_title',
  launch_date = 'launch_date',
  document_name = 'document_name',
  document_date = 'document_date',
}
